export enum EnumPatServiceStatus {
    none = 0,
    Booked = 1,
    Arrived = 2,
    CheckIn = 3,
    CheckOut = 4,
    Cancel = 5,
    NotShow = 6,
    Future = 7,
    NeedApproval = 8,
    BarcodeWrited = 9,
    SampleCollected = 10,
    ServiceSenedToDep = 11,
    DeviceDetected = 12,
    ResultWrited = 13,
    ResultInsured = 14,
    ResultPrinted = 15,
    ResultDelivered = 29,
    RadStartOnModality = 16,
    RadEndFromModality = 17,
    RadWriteReport = 18,
    RadReviewReport = 19,
    Scheduled = 30,
    LabSendToOutsideLab = 31,
    LabReceiveFromOutsideLab = 32,
    PatientCall = 33,
    SurgeonArrival = 34,
    AnesthesiaBegin = 35,
    AnesthesiaWakeUp = 36,
    patientArrive = 37,
    SurgeryStart = 38,
    SurgeryEnd = 39,
    AUp = 40,
    StartSession = 41,
    EndSession = 42,
    StarthemoDialsis = 43,
    EndhemoDialsis = 44,
    DeleveryResult = 45,
    SampleReceive = 46 
}


